import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	resizer: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	resizer: {
		id: 'flex-resizer.handle.resizer',
		defaultMessage: 'Resize work item view side panel',
		description: 'Button label for resizing the work item view side panel',
	},
});
export default messages;
